import React, { useState } from 'react';
import { FaFileExcel, FaFileWord, FaSave, FaFolderPlus } from 'react-icons/fa';

const NavigationButtons = ({ onExportToExcel, onExportToWord, onSaveResults, onSaveAsNewFolder }) => {
  const [isExportingWord, setIsExportingWord] = useState(false);

  const handleWordClick = async () => {
    if (!onExportToWord || isExportingWord) return;
    setIsExportingWord(true);
    try {
      await onExportToWord();
    } finally {
      setIsExportingWord(false);
    }
  };

  return (
    <div className="flex flex-wrap gap-2">
      <button
        onClick={onExportToExcel}
        className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded flex items-center"
      >
        <FaFileExcel className="mr-2" />
        Excel'e Aktar
      </button>

      <button
        onClick={handleWordClick}
        disabled={isExportingWord}
        className="bg-indigo-500 hover:bg-indigo-600 disabled:bg-indigo-400 disabled:cursor-wait text-white font-bold py-2 px-4 rounded flex items-center"
      >
        <FaFileWord className="mr-2" />
        {isExportingWord ? 'Hazırlanıyor…' : 'Word\'e Aktar'}
      </button>

      <button
        onClick={onSaveResults}
        className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded flex items-center"
      >
        <FaSave className="mr-2" />
        Sonuçları Kaydet
      </button>

      {onSaveAsNewFolder && (
        <button
          onClick={onSaveAsNewFolder}
          className="border-2 border-blue-500 bg-white hover:bg-blue-50 text-blue-700 font-bold py-2 px-4 rounded flex items-center transition"
          title="Birleşik dağıtımı YENİ bir klasöre kaydet (eski kayıtlar ve hakim puanları korunur)"
        >
          <FaFolderPlus className="mr-2" />
          Farklı Kaydet
        </button>
      )}
    </div>
  );
};

export default NavigationButtons;